import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Personal from "./pages/Personal";
import Corporate from "./pages/Corporate";
import Insurance from "./pages/Insurance";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import UserLogin from "./pages/UserLogin";
import UserRegister from "./pages/UserRegister";
import UserDashboard from "./pages/UserDashboard";
import LoansAndMortgages from "./pages/services/LoansAndMortgages";
import SavingsAndInvestments from "./pages/services/SavingsAndInvestments";
import BusinessAccounts from "./pages/services/BusinessAccounts";
import OnlineBanking from "./pages/services/OnlineBanking";
import Consultation from "./pages/services/Consultation";
import ScrollToTop from "./components/ScrollToTop";
import BackToTop from "./components/BackToTop";
import FloatingChatWidget from "./components/FloatingChatWidget";
import { Toaster } from "./components/ui/toaster";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <BackToTop />
          <FloatingChatWidget />
          <Routes>
            {/* Public Routes with Navbar/Footer */}
            <Route path="/" element={
              <>
                <Navbar />
                <Home />
                <Footer />
              </>
            } />
            <Route path="/about" element={
              <>
                <Navbar />
                <About />
                <Footer />
              </>
            } />
            <Route path="/personal" element={
              <>
                <Navbar />
                <Personal />
                <Footer />
              </>
            } />
            <Route path="/corporate" element={
              <>
                <Navbar />
                <Corporate />
                <Footer />
              </>
            } />
            <Route path="/insurance" element={
              <>
                <Navbar />
                <Insurance />
                <Footer />
              </>
            } />
            
            {/* Service Pages */}
            <Route path="/services/loans-mortgages" element={
              <>
                <Navbar />
                <LoansAndMortgages />
                <Footer />
              </>
            } />
            <Route path="/services/savings-investments" element={
              <>
                <Navbar />
                <SavingsAndInvestments />
                <Footer />
              </>
            } />
            <Route path="/services/business-accounts" element={
              <>
                <Navbar />
                <BusinessAccounts />
                <Footer />
              </>
            } />
            <Route path="/services/online-banking" element={
              <>
                <Navbar />
                <OnlineBanking />
                <Footer />
              </>
            } />
            <Route path="/services/consultation" element={
              <>
                <Navbar />
                <Consultation />
                <Footer />
              </>
            } />

            {/* Contact Route */}
            <Route path="/contact" element={
              <>
                <Navbar />
                <Contact />
                <Footer />
              </>
            } />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={
              <ProtectedRoute requireAdmin>
                <AdminDashboard />
              </ProtectedRoute>
            } />

            {/* User Routes */}
            <Route path="/user/login" element={<UserLogin />} />
            <Route path="/user/register" element={<UserRegister />} />
            <Route path="/user/dashboard" element={
              <ProtectedRoute requireCustomer>
                <UserDashboard />
              </ProtectedRoute>
            } />

            {/* Redirect /login to user login */}
            <Route path="/login" element={<Navigate to="/user/login" replace />} />
          </Routes>
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
